module.exports = __webpack_public_path__ + "img/ssl_certificate-dashboard.3c1a0b93.svg";